(function () {
  // Helper: read the quantities from the shared header row
  function getBreakpointsFromHeader() {
    const headerRow = document.querySelector("#volume-quantities-cells .volume-price-nested-headers tr");
    if (!headerRow) return null;

    const nums = Array.from(headerRow.children)
      .map((cell) => {
        // Extract the first integer (handles "ab 1", "≥ 5", etc.)
        const m = cell.textContent.replace(/\s+/g, " ").match(/(\d+)/);
        return m ? parseInt(m[1], 10) : null;
      })
      .filter((n) => Number.isFinite(n));

    // De-dupe, ensure ascending order
    const uniq = Array.from(new Set(nums)).sort((a, b) => a - b);
    return uniq.length ? uniq : null;
  }

  // Inject a thead into each variant nested table that mirrors the shared header
  function addMobileHeaders() {
    const breaks = getBreakpointsFromHeader();
    if (!breaks) return;

    // Use the exact labels from the header row to keep translations/symbols
    const headerCells = Array.from(
      document.querySelectorAll("#volume-quantities-cells .volume-price-nested-headers tr > *")
    ).map((c) => c.textContent.trim());

    // For each variant price nested table
    document.querySelectorAll("td.volume-prices .volume-price-nested-table, .volume-prices .volume-price-nested-table").forEach((nestedTable) => {
      // Avoid duplicates
      if (nestedTable.querySelector("thead.mobile-volume-headers")) return;

      const thead = document.createElement("thead");
      thead.className = "mobile-volume-headers";

      const tr = document.createElement("tr");
      headerCells.forEach((label) => {
        const th = document.createElement("th");
        th.textContent = label; // e.g., "ab 1", "ab 5", ...
        tr.appendChild(th);
      });

      thead.appendChild(tr);
      nestedTable.insertBefore(thead, nestedTable.firstChild);
    });
  }

  // Throttled resize
  let resizeT;
  function onResize() {
    clearTimeout(resizeT);
    resizeT = setTimeout(addMobileHeaders, 150);
  }

  // Init hooks
  document.addEventListener("DOMContentLoaded", addMobileHeaders);
  document.addEventListener("shopify:section:load", addMobileHeaders);
  window.addEventListener("resize", onResize);
})();